import { ModalSearchListener } from "../../../components/modal-search/modal-search-listener";
import type { SearchCategoryModalHandler } from "./search-category-modal-handler";

const SEARCH_CATEGORY_MODAL_DATA_UPDATED_EVENT = "search-category-modal:data-updated";
let isRefreshEventBound = false;

interface SearchCategoryModalRefreshPayload {
    apiData?: unknown;
}

function hasNestedData(value: unknown): value is { data?: unknown } {
    return !!value && typeof value === "object" && !Array.isArray(value) && "data" in value;
}

export interface SearchCategoryModalRefreshParams {
    getHandler: () => SearchCategoryModalHandler | null;
}

export interface SearchCategoryModalListenerParams {
    rootEl: Document | HTMLElement;
    overlayEl: HTMLElement;
    modalEl: HTMLElement;
    closeBtnEl: HTMLElement | null;
    listEl: HTMLElement;
    filterInputEl: HTMLInputElement | null;
    handler: SearchCategoryModalHandler;
}

export class SearchCategoryModalListener {
    public static bindShowAllToggle(toggleEl: HTMLInputElement, onChange: () => void): void {
        toggleEl.addEventListener("change", onChange);
    }

    public static bindDataUpdatedRefresh(params: SearchCategoryModalRefreshParams): void {
        if (isRefreshEventBound) return;

        const getHandler = typeof params?.getHandler === "function" ? params.getHandler : null;
        if (!getHandler) return;

        document.addEventListener(SEARCH_CATEGORY_MODAL_DATA_UPDATED_EVENT, (event) => {
            const payload =
                event instanceof CustomEvent ? (event.detail as SearchCategoryModalRefreshPayload | null) : null;
            if (!payload || typeof payload !== "object") return;

            const raw = payload.apiData;
            const apiData = hasNestedData(raw) && raw.data ? raw.data : raw;
            if (!apiData) return;

            const handler = getHandler();
            if (!handler) return;

            handler.setApiData(apiData);
            handler.render();
        });

        isRefreshEventBound = true;
    }

    public static setup(params: SearchCategoryModalListenerParams): void {
        const { rootEl, overlayEl, modalEl, closeBtnEl, listEl, filterInputEl, handler } = params;

        ModalSearchListener.setup({
            rootEl,
            scopeKey: "search-category-modal",
            overlayEl,
            modalEl,
            closeBtnEl,
            filterInputEl,
            actionRootEls: [listEl],
            base: handler.getBase(),
        });
    }
}
